import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBDataTable  } from 'mdbreact';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';



export default class superadminsucceed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle.php')
          api.get('registercon/selectArticleconnpayforadminpassfinish')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
        //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle.php')
        api.get('registercon/selectArticleconnpayforadminpassfinish')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {


      const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อเรื่อง',
            field: 'name_article',
            sort: 'name_article',
            width: 150
          },
          {
            label: 'กลุ่มเนื้อหา',
            field: 'presentype_name',
            sort: 'presentype_name',
            width: 150
          },
          {
            label: 'ผู้เขียนบทความ',
            field: 'name_present',
            sort: 'name_present',
            width: 150
          },
         
          {
            label: 'ไฟล์บทความ',
            field: 'send_uploadeword1',
            sort: 'send_uploadeword1',
            width: 150
          },
      
        
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
      
          {
     
             list: <>{i+1}</>,
             name_article: <>{data.name_article}</>,
             presentype_name: <>{data.presentype_name}</>,
             name_present: <>{data.name_present}</>,
            
             send_uploadeword1: <><MDBBtn color="indigo" size="sm" href={`${this.state.url+data.send_uploadeword1}`}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={`${this.state.url+data.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn></>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อบทความ"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
             theadColor="grey lighten-1"
          //  theadColor={"#ff4444"}
            />

        return (
            <MDBContainer fluid>
            <div>
            {/* <MDBIcon fas icon="book-open" /> */}
            <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 4 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
            <MDBAlert color="secondary" >
                    <PageHeader
                        className="site-page-header"
                       // onBack={() => null}
                        title="บทความผ่านพิจารณาแล้ว"
                        subTitle="บทความผ่านพิจารณาแล้ว"
                        avatar={{ src: 'https://www.tutoroui-plus.com/assets/img/icon/icon01.png' }}
                       // backIcon={() => null}
                    />
            </MDBAlert>
               {persons}  
                {/* <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้เขียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.name_article}</td>
                        <td>{article.name_present}</td>
                        <td>{article.major_precent}</td>
                        <td>
                         
                          <MDBBtn color="indigo" size="sm" href={`https://conference.kpru.ac.th/PHPAPI/upload/${article.send_uploadeword1}`}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={`https://conference.kpru.ac.th/PHPAPI/upload/${article.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                          </td>
                      
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}

            </div>
            </MDBContainer>
        )
    }
}
